import { Outlet, useLocation } from 'react-router'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-spring-bottom-sheet/dist/style.css'

import { UserProvider } from '@/routes/use_auth'
import { Container } from '@/components'
import { Images } from '@/assets'

export const App = () => {
	const { pathname } = useLocation()

	const meta = document.querySelector('meta[name="theme-color"]')
	meta?.setAttribute('content', '#eafff1')

	if (pathname.includes('quest') || pathname.includes('stamp')) {
		meta?.setAttribute('content', '#7A5020')
	} else {
		meta?.setAttribute('content', '#eafff1')
	}

	return (
		<Container>
			{/* <UserProvider>
        <Outlet />
      </UserProvider> */}
			<div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
				<div className="max-w-md w-full bg-white shadow-lg rounded-2xl p-4 text-center">
					<div className="flex items-center justify-center text-4xl mb-4">
						<img
							className="h-28 my-4"
							src={Images.madcoco_logo_2}
							alt="madcoco"
						/>
					</div>

					<h1 className="text-xl font-semibold text-primary">
						Layanan ini sudah tidak tersedia
					</h1>

					<p className="text-sm text-slate-600">
						Kami berterima kasih atas dukungan dan kebersamaan Anda. 🙏
					</p>

					<hr className="my-2 border-slate-100" />

					<p className="text-xs text-slate-400 leading-relaxed">
						Jika Anda memiliki pertanyaan lebih lanjut, <br />
						silakan hubungi{' '}
						<span
							className="font-bold underline cursor-pointer"
							onClick={() => window.open(`https://wa.me/6283170036868`)}
						>
							Customer Service
						</span>
						.
					</p>
				</div>
				<div className="fixed bottom-4 flex flex-col justify-center items-center mt-4">
					<div className="font-outfit font-semi-bold text-xs text-black/60 text-center mt-3">
						Powered by
					</div>
					<img
						className="inline-block h-8 mt-2 cursor-pointer pointer-events-auto"
						src={Images.loyalid_blue}
						alt="logo"
						onClick={() => window.open('https://loyal.id')}
					/>
				</div>
			</div>
		</Container>
	)
}
